export const ANY_RESULT = "__ANY__"
const VALUE_PREFIX = "value:"

export function parseTraceValues(
  value: string | number | undefined,
): string[] | null {
  if (typeof value !== "string") {
    return null
  }
  try {
    const parsed: unknown = JSON.parse(value)
    return Array.isArray(parsed) &&
      parsed.every((item) => typeof item === "string")
      ? parsed
      : null
  } catch {
    return null
  }
}

export function formatTraceValues(values: string[]): string {
  return values.length
    ? values
        .map((value) => (value === "" ? "(empty string)" : value))
        .join(", ")
    : "No values"
}

export function encodeTraceValue(value: string): string {
  return VALUE_PREFIX + JSON.stringify(value)
}

export function decodeTraceValue(value: string): string | null {
  if (!value.startsWith(VALUE_PREFIX)) {
    return null
  }
  try {
    const parsed: unknown = JSON.parse(value.slice(VALUE_PREFIX.length))
    return typeof parsed === "string" ? parsed : null
  } catch {
    return null
  }
}

export function recentMetricValueOptions(
  items:
    | Array<{
        metricsById?: Record<string, string | number>
        metricOutputTypesById?: Record<string, string>
      }>
    | undefined,
  metricId: string | undefined,
  isFloatMetric: boolean,
  isValuesMetric: boolean,
  isTraceMetric = false,
): string[] {
  if ((isFloatMetric && !isTraceMetric) || !metricId) {
    return []
  }
  const seen = new Set<string>()
  for (const item of items ?? []) {
    const value = item.metricsById?.[metricId]
    if (
      isValuesMetric ||
      (isTraceMetric && item.metricOutputTypesById?.[metricId] === "set")
    ) {
      for (const entry of parseTraceValues(value) ?? []) {
        seen.add(entry)
      }
    } else if (!isFloatMetric && typeof value === "string" && value) {
      seen.add(value)
    }
  }
  return [...seen].sort()
}
